<my-bill-odb-page-base-structure
  [billingDocument]="billingDocument"
  [hasCommonHeader]="true"
  [hasCustomHeader]="address"
  [customTitle]="categoryLabelKey | translate"
  *ngIf="hasDataAvailable && !isFetching; else showSkeleton"
>
  <!--///////////////   custom header content   //////////////////-->
  <ng-container customHeader>
    <div
      class="row collapse"
      *ngIf="address"
      data-cy="myBillOdbCategoryDetailsAddress"
    >
      <div class="rs-auto">
        <i
          class="icon-Place-map rs-margin-right1 rs-txt-s7 rs-txt-c2 icon-lh"
          aria-hidden="true"
        ></i>
      </div>
      <div class="rs-last">
        <p class="rs-txt-s5 rs-font-pxB">{{ address }}</p>
      </div>
    </div>
    <div
      class="row"
      *ngIf="
        !hasError &&
        productSplit?.length > 1 &&
        (category === 'usage' || category === 'oneTimeCharge')
      "
    >
      <div class="columns small-12 medium-5">
        <my-bill-odb-product-split-header
          [productSplit]="productSplit"
          [selectedProductSplitIdentifier]="selectedProductSplitIdentifier"
          (handleChangeOfSelectedItendifier)="
            handleChangeOfSelectedItendifier($event)
          "
        ></my-bill-odb-product-split-header>
      </div>
    </div>
  </ng-container>
  <!--///////////////   LEFT Column content   //////////////////-->
  <ng-container leftColumnContent>
    <ng-container *ngIf="!hasError; else showError">
      <ng-container [ngSwitch]="division.type">
        <my-bill-odb-explanation-intro
          [billExplanationType]="category ?? division.type"
          *ngIf="shouldDisplayInfoSection() && category !== 'oneTimeCharge'"
        ></my-bill-odb-explanation-intro>
        <ng-container
          *ngIf="shouldDisplayInfoSection() && category === 'oneTimeCharge'"
        >
          <ng-container *ngFor="let explanationType of explanationsIntroPages">
            <my-bill-odb-explanation-intro
              [billExplanationType]="explanationType"
            ></my-bill-odb-explanation-intro>
          </ng-container>
        </ng-container>
        <my-bill-odb-vat-product-split
          *ngSwitchCase="'vat'"
          [productSplit]="productSplit"
          [totalAmount]="amount"
        >
        </my-bill-odb-vat-product-split>
        <my-bill-odb-settlement-product-split
          *ngSwitchCase="'settlement'"
          [productSplit]="productSplit"
          [totalAmount]="amount"
        >
        </my-bill-odb-settlement-product-split>
        <ng-container *ngSwitchCase="'thirdParty'">
          <my-bill-odb-third-party-product-split
            [productSplit]="productSplit"
            [totalAmount]="amount"
            [customerId]="customerId"
            [customerSubsegment]="customerSubsegment"
            [customerGlobalId]="customerGlobalId"
            [customerMobile]="customerMobile"
            [billingAccount]="billingAccount"
            [billingDocument]="billingDocument"
            [openTransactionToPayIndex]="openTransactionToPayIndex"
          >
          </my-bill-odb-third-party-product-split>
        </ng-container>
      </ng-container>
      <ng-container [ngSwitch]="category">
        <my-bill-odb-subscription-product-split
          *ngSwitchCase="'subscription'"
          [productSplit]="productSplit"
          [totalAmount]="amount"
          [divisionType]="division.type"
          [billingAccountNumber]="billingAccount.accountNumber"
          [documentReference]="documentReference"
        ></my-bill-odb-subscription-product-split>
        <my-bill-odb-usage-and-otc-product-split
          *ngSwitchCase="'usage'"
          [productSplit]="productSplit"
          [filteredProductSplit]="filteredProductSplit"
          [totalAmount]="amount"
          category="usage"
          [divisionType]="division.type"
          [billingAccountNumber]="billingAccount.accountNumber"
          [documentReference]="documentReference"
          [divisionIdentifier]="division.identifier"
        ></my-bill-odb-usage-and-otc-product-split>

        <my-bill-odb-usage-and-otc-product-split
          *ngSwitchCase="'oneTimeCharge'"
          [productSplit]="productSplit"
          [filteredProductSplit]="filteredProductSplit"
          [totalAmount]="amount"
          category="oneTimeCharge"
          [divisionType]="division.type"
          [billingAccountNumber]="billingAccount.accountNumber"
          [documentReference]="documentReference"
          [divisionIdentifier]="division.identifier"
        ></my-bill-odb-usage-and-otc-product-split>
      </ng-container>
    </ng-container>
    <ng-template #showError>
      <div class="rs-bg-c2 rs-radius">
        <lib-generic-message-box
          [messageType]="messageBoxTypeError"
          [showCross]="false"
        >
          <ng-container Title>{{
            'bills.cover.odbDetails.serviceUnavailable.title' | translate
          }}</ng-container>
          <p Content>
            {{
              'bills.cover.odbDetails.serviceUnavailable.message' | translate
            }}
          </p>
        </lib-generic-message-box>
      </div>
    </ng-template>
  </ng-container>
  <!--///////////////   RIGHT Column content   //////////////////-->
</my-bill-odb-page-base-structure>

<ng-template #showSkeleton>
  <my-bill-odb-page-base-structure
    [billingDocument]="billDocument"
    [hasTopContent]="true"
  >
    <my-bill-overview-redesign-skeleton topContent>
    </my-bill-overview-redesign-skeleton>
  </my-bill-odb-page-base-structure>
</ng-template>

<my-bill-pdf-error-overlayer></my-bill-pdf-error-overlayer>
